import type PointStyleSettingsModule from "./pointStyleSettingsModule";

export default class SchedulePointStyleSettingsModule {
    private pointStyleSettings: PointStyleSettingsModule;

    constructor(pointStyleSettings: PointStyleSettingsModule) {
        this.pointStyleSettings = pointStyleSettings;
    }

    /**
     * 
     * @param styleSettings 
     * @param territoryModel 
     * 
     * @returns 
     */
    getRequiredAttributes(styleSettings, territoryModel): string[] {
        return this.pointStyleSettings.getRequiredAttributes(styleSettings, territoryModel);
    }
}
